module.exports = __webpack_public_path__ + "img/help_dataset_svg_small.5472fa0a.png";